import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/CaretDoubleRight.es.js";
const o = e.forwardRef((t, r) => /* @__PURE__ */ e.createElement(a, { ref: r, ...t, weights: i }));
o.displayName = "CaretDoubleRightIcon";
const s = o;
export {
  s as CaretDoubleRight,
  o as CaretDoubleRightIcon
};
